var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React from "react";
import React__default from "react";
import ReactDom from "react-dom";
function getCookie(name) {
  var _a, _b;
  if (typeof document === "undefined") {
    return null;
  }
  try {
    return (_b = (_a = document.cookie.match(new RegExp(`(?:^|;)\\s*${name}=([^;]*)`))) == null ? void 0 : _a[1]) != null ? _b : null;
  } catch (e) {
    return null;
  }
}
function setCookie(name, value) {
  var _a;
  if (typeof document === "undefined") {
    return;
  }
  const maxAge = value === null ? 0 : 14 * 24 * 60 * 60;
  const match = window.location.hostname.match(/(?:.*\.|^)([^.]+\.[^.]+)$/);
  try {
    document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; domain=${(_a = match == null ? void 0 : match[1]) != null ? _a : window.location.hostname}`;
  } catch (e) {
  }
}
class ToolsListener {
  constructor() {
    __publicField(this, "callbacks", []);
  }
  subscribe(callback) {
    this.callbacks.push(callback);
  }
  unsubscribe(callback) {
    if (callback) {
      const index = this.callbacks.indexOf(callback);
      if (index !== -1) {
        this.callbacks.splice(index, 1);
      }
    } else {
      this.callbacks.length = 0;
    }
  }
  fire() {
    this.callbacks.forEach((callback) => {
      callback();
    });
  }
}
const CookieName$1 = "translationVersions";
class ToolsVersions extends ToolsListener {
  constructor() {
    super();
    __publicField(this, "list", new Map());
    const cachedVersions = getCookie(CookieName$1);
    if (cachedVersions) {
      this.list = new Map(JSON.parse(cachedVersions));
    }
  }
  reset(projectName) {
    this.list.delete(projectName);
    this.saveSelectedProjects();
  }
  resetAll() {
    this.list.clear();
    this.saveSelectedProjects();
  }
  setProject(projectName, versionName) {
    this.list.set(projectName, versionName);
    this.saveSelectedProjects();
  }
  saveSelectedProjects() {
    const value = this.list.size > 0 ? JSON.stringify([...this.list]) : null;
    setCookie(CookieName$1, value);
    this.fire();
  }
}
const ZeroWidthSpace = "\u200B";
const ZeroWidthNoBreakSpace = "\uFEFF";
const ZeroWidthJoiner = "\u200D";
const ZeroWidthNonJoiner = "\u200C";
const FrameStart = `${ZeroWidthJoiner}${ZeroWidthNonJoiner}`;
const FrameEnd = `${ZeroWidthNonJoiner}${ZeroWidthJoiner}`;
const ZeroNotation = ZeroWidthSpace;
const OneNotation = ZeroWidthNoBreakSpace;
const CharSpacer = ZeroWidthNonJoiner;
const serializedBitRegExp = new RegExp(`^[${CharSpacer}${OneNotation}${ZeroNotation}]+`, "u");
const BitMap = {
  0: ZeroNotation,
  1: OneNotation
};
const BitNotationMap = {
  [ZeroNotation.charCodeAt(0)]: "0",
  [OneNotation.charCodeAt(0)]: "1"
};
function serializeChar(char) {
  return Array.from(char.charCodeAt(0).toString(2)).map((bit) => {
    var _a;
    return (_a = BitMap[bit]) != null ? _a : "";
  }).join("");
}
function serialize(value) {
  return Array.from(value).map((char) => serializeChar(char)).join(CharSpacer);
}
function serializeMeta(meta) {
  return serialize(JSON.stringify(meta));
}
function prepareLogStamp(meta, translation) {
  return [FrameStart, serializeMeta(meta), translation, FrameEnd];
}
function deserializeChar(value) {
  const binary = Array.from(value).map((bitNotation) => {
    var _a;
    return (_a = BitNotationMap[bitNotation.charCodeAt(0)]) != null ? _a : "";
  }).join("");
  return String.fromCharCode(parseInt(binary, 2));
}
function deserialize(value) {
  return value.split(CharSpacer).map((serializedChar) => deserializeChar(serializedChar)).join("");
}
function getStampData(stamp) {
  return JSON.parse(deserialize(stamp));
}
function hasTranslation(element) {
  var _a, _b;
  if (isNodeAnElement(element)) {
    return element.outerHTML.includes(FrameStart);
  }
  return (_b = (_a = element.textContent) == null ? void 0 : _a.includes(FrameStart)) != null ? _b : false;
}
function getClosestNode(element) {
  let parent = element;
  while (parent && parent !== document.body) {
    if (hasTranslation(parent)) {
      return parent;
    }
    parent = parent.parentNode;
  }
  return null;
}
function getStampInfo(text) {
  var _a, _b;
  const endIndex = text.indexOf(FrameEnd);
  if (endIndex === -1) {
    return null;
  }
  const startIndex = text.lastIndexOf(FrameStart, endIndex);
  if (startIndex === -1) {
    console.error("Ending without start");
    return null;
  }
  const full = text.slice(startIndex, endIndex + FrameEnd.length);
  const frameless = full.slice(FrameStart.length, -FrameEnd.length);
  const stamp = (_b = (_a = frameless.match(serializedBitRegExp)) == null ? void 0 : _a[0]) != null ? _b : "";
  return {
    full,
    stamp,
    text: frameless.slice(stamp.length)
  };
}
function getAllStampInfo(text) {
  let content = text;
  let stampInfo = getStampInfo(content);
  let count = 0;
  const data = [];
  while (stampInfo) {
    data.push(getStampData(stampInfo.stamp));
    content = content.replace(stampInfo.full, stampInfo.text);
    stampInfo = getStampInfo(content);
    count++;
    if (count > 10) {
      console.warn("Something went wrong with parsing translation data");
      break;
    }
  }
  return data;
}
function getTranslationsFromElement(element) {
  var _a;
  const content = (_a = element.textContent) != null ? _a : "";
  const data = [];
  data.push(...getAllStampInfo(content));
  if (isNodeAnElement(element)) {
    Array.from(element.attributes).forEach(({ name, value }) => {
      const attrStampInfo = getAllStampInfo(value);
      if (attrStampInfo.length) {
        data.push(...attrStampInfo.map((info) => __spreadProps(__spreadValues({}, info), {
          attr: name
        })));
      }
    });
  }
  return data;
}
function getClosestTranslation(element) {
  const container = getClosestNode(element);
  if (container) {
    return { container, data: getTranslationsFromElement(container) };
  }
  return null;
}
function isNodeAnElement(node) {
  return (node == null ? void 0 : node.nodeType) === 1;
}
function getTargetNode(event) {
  var _a, _b, _c;
  if ("caretRangeFromPoint" in document) {
    const range = document.caretRangeFromPoint(event.clientX, event.clientY);
    return (_a = range == null ? void 0 : range.startContainer) != null ? _a : null;
  } else if ("caretPositionFromPoint" in document) {
    const point = document.caretPositionFromPoint(event.clientX, event.clientY);
    return (_b = point == null ? void 0 : point.offsetNode) != null ? _b : null;
  }
  return (_c = event.target) != null ? _c : null;
}
function TranslationToolbar() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [translations, setTranslations] = React.useState([]);
  const [node, setNode] = React.useState(null);
  const outline = React.useRef(null);
  const handleClick = React.useCallback(() => setIsOpen((prev) => !prev), []);
  const handleMouseMove = React.useCallback((event) => {
    var _a;
    const target = getTargetNode(event);
    if (target) {
      if (outline.current && (outline.current === target || outline.current.contains(target))) {
        return;
      }
      const { container, data } = (_a = getClosestTranslation(target)) != null ? _a : {
        container: null,
        data: []
      };
      data.forEach((info) => {
        var _a2, _b, _c, _d, _e;
        if ("key" in info) {
          const { key } = info;
          const spacerInfo = (_c = window.TranslationTools) == null ? void 0 : _c.Overlay.getSpaceInfo((_b = (_a2 = key.split(".")) == null ? void 0 : _a2[0]) != null ? _b : "");
          info.raw = (_e = (_d = window.TranslationTools) == null ? void 0 : _d.Overlay.getTranslation(key)) != null ? _e : "";
          if (spacerInfo) {
            info.project = spacerInfo.getProject() || "";
            info.version = spacerInfo.getVersion() || "";
          }
        }
      });
      setNode(container);
      setTranslations(data);
    }
  }, []);
  const handleCopyClick = React.useCallback((event) => {
    var _a;
    const value = (_a = event.currentTarget.getAttribute("data-value")) != null ? _a : "";
    navigator.clipboard.writeText(value);
  }, []);
  React.useEffect(() => {
    if (isOpen) {
      setNode(null);
      document.body.addEventListener("mousemove", handleMouseMove, true);
      return () => {
        document.body.removeEventListener("mousemove", handleMouseMove, true);
      };
    }
    return void 0;
  }, [handleMouseMove, isOpen]);
  const handleCopy = React.useCallback((event) => {
    var _a;
    const selection = document.getSelection();
    if (selection && !selection.isCollapsed) {
      (_a = event.clipboardData) == null ? void 0 : _a.setData("text/plain", selection.toString().replace(/[\u{200D}\u{200C}\u{feff}\u{200b}]*/gu, ""));
      event.preventDefault();
    }
  }, []);
  React.useEffect(() => {
    document.addEventListener("copy", handleCopy);
    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, [handleCopy]);
  const rect = React.useMemo(() => {
    var _a;
    if (isNodeAnElement(node)) {
      return node.getBoundingClientRect();
    }
    if (node) {
      return (_a = node == null ? void 0 : node.parentElement) == null ? void 0 : _a.getBoundingClientRect();
    }
    return null;
  }, [node]);
  return /* @__PURE__ */ React.createElement("div", {
    style: { position: "fixed", top: 0, left: 0, zIndex: 9999999 }
  }, rect ? /* @__PURE__ */ React.createElement("div", {
    style: {
      outline: "1px solid pink",
      position: "absolute",
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      zIndex: 9999999999999,
      pointerEvents: "none"
    },
    ref: outline
  }, /* @__PURE__ */ React.createElement("div", {
    style: {
      position: "absolute",
      top: "100%",
      maxHeight: `calc(100vh - ${rect.top}px - 100% - 50px)`,
      maxWidth: `calc(100vw - ${rect.left}px - 50px)`,
      overflow: "auto",
      background: "pink",
      pointerEvents: "all"
    }
  }, translations.map((item, index) => /* @__PURE__ */ React.createElement("table", {
    key: index,
    style: { borderBottom: "1px solid black", width: "100%", borderSpacing: 5 }
  }, /* @__PURE__ */ React.createElement("tbody", null, Object.entries(item).map(([key, value]) => value ? /* @__PURE__ */ React.createElement("tr", {
    key
  }, /* @__PURE__ */ React.createElement("td", {
    style: { minWidth: 80, fontWeight: 700 }
  }, key), /* @__PURE__ */ React.createElement("td", {
    style: { display: "flex", justifyContent: "space-between" }
  }, value, key === "key" || key === "raw" ? /* @__PURE__ */ React.createElement("button", {
    type: "button",
    "data-value": value,
    style: { marginLeft: 5 },
    onClick: handleCopyClick
  }, "copy") : null)) : null)))))) : null, /* @__PURE__ */ React.createElement("div", {
    role: "presentation",
    title: isOpen ? "Open translation toolbar" : "Close translation toolbar",
    style: {
      position: "absolute",
      borderRadius: "50%",
      width: 20,
      height: 20,
      top: 10,
      left: 10,
      background: isOpen ? "red" : "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999999999999,
      boxShadow: "black 0px 0px 7px"
    },
    onClick: handleClick
  }));
}
const CookieName = "translationOverlay";
const CookieTrueValue = "true";
class ToolsOverlay extends ToolsListener {
  constructor(getTranslation) {
    super();
    __publicField(this, "status");
    __publicField(this, "container");
    __publicField(this, "spacerInfo", {});
    this.getTranslation = getTranslation;
    this.changeStatus(getCookie(CookieName) === CookieTrueValue);
  }
  off() {
    this.changeStatus(false);
    this.fire();
  }
  on() {
    this.changeStatus(true);
    this.fire();
  }
  isOn() {
    return this.status;
  }
  stampTranslation(meta, translation) {
    return prepareLogStamp(meta, translation);
  }
  registerSpaceInfo(spaceInfo) {
    this.spacerInfo[spaceInfo.getSpace()] = spaceInfo;
  }
  getSpaceInfo(space) {
    var _a;
    return (_a = this.spacerInfo[space]) != null ? _a : null;
  }
  changeStatus(status) {
    this.status = status;
    this.saveStatus();
    this.renderToolbar();
  }
  renderToolbar() {
    var _a;
    this.container = (_a = this.container) != null ? _a : document.createElement("div");
    if (this.status) {
      document.body.append(this.container);
      ReactDom.render(/* @__PURE__ */ React__default.createElement(TranslationToolbar, null), this.container);
    } else if (this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
  }
  saveStatus() {
    setCookie(CookieName, this.status ? CookieTrueValue : null);
  }
}
class TranslationTools {
  constructor(getTranslation) {
    __publicField(this, "Versions", new ToolsVersions());
    __publicField(this, "Overlay");
    this.Overlay = new ToolsOverlay(getTranslation);
  }
}
export { TranslationTools };
